export default __webpack_public_path__ + "assets/icons/contact_mobile_noJp.84bca398.svg";